import moment from 'moment'

function replaceRange(s: string, start: number, end: number, substitute: string) {
  let test = s.substring(start, end)
  let string = ''
  for (let i = 0; i < test.length; i++) {
    string += substitute
  }
  return s.substring(0, start) + string + s.substring(end)
}

export const FormatDate = (date: string) => {
  var dateFormat = moment(date, 'YYYY/MM/DD').format('DD/MM/YYYY')
  return dateFormat
}

export const FormatDateTime = (date: string) => {
  var dateFormat = moment(date, 'YYYY/MM/DD HH:mm').format('DD/MM/YYYY HH:mm')
  return dateFormat
}

export const FormatEmail = (email: string) => {
  return email.replace(/(\w{3})[\w.-]+@([\w.]+\w)/, '$1***@$2')
}

export const FormatIdentity = (identity: string) => {
  return replaceRange(identity, 3, identity.length - 2, '*')
}
